import { FC } from "react";
import { IconProps } from "./types";

export const ArrowRightCircleFilled: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12c0-6.6-5.4-12-12-12S0 5.4 0 12s5.4 12 12 12 12-5.4 12-12zM13.174 6c.157 0 .314.079.392.158l5.402 5.447a.605.605 0 0 1 .157.395c0 .04-.02.079-.04.118a.282.282 0 0 0-.038.119c-.049 0-.067.03-.093.072-.015.025-.034.056-.064.086l-5.402 5.447a.595.595 0 0 1-.392.158.276.276 0 0 1-.117-.04.277.277 0 0 0-.118-.039c0-.049-.03-.067-.071-.093a.44.44 0 0 1-.085-.065c-.079 0-.157-.079-.157-.158-.078-.079-.078-.158-.078-.237 0-.04.02-.078.039-.118.02-.04.04-.079.04-.118.048 0 .066-.03.091-.072.016-.026.035-.056.065-.086l4.384-4.421H5.423a.595.595 0 0 1-.391-.158.605.605 0 0 1-.157-.395c0-.158.078-.316.157-.474a.596.596 0 0 1 .391-.158h11.745l-4.385-4.42a.606.606 0 0 1-.157-.395c0-.158.079-.316.157-.395.078-.158.235-.158.391-.158z"
      fill={fill}
    />
  </svg>
);
